import React, { useEffect, useState } from "react";
import { ActivityIndicator, Dimensions, Platform, ScrollView, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { ButtonSizeDLS, ButtonTypeDLS, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, IconSizeTokens, IconTokens, ImageSizeTokens, SizeTypeTokens, StepperTypeTokens, TextAlignTokens, TypographyTypeDLS, } from "@voltmoney/schema";
import { ModalAlignmentEnum, SCREEN_SIZE } from '@voltmoney/types';
import { Button } from "../../button/Button";
import { Image } from "../../image/Image";
import BottomSheet from "../BottomSheet";
import { isMobile, isMobileView } from "../../stack/utils";
import { Typography } from "../../typography/Typography";
import { getLenderIcon } from "../utils";
import WebView from "react-native-webview";
import { Header } from "../../header/Header";
import { Icon } from "../../icon/Icon";
import LottieView from "lottie-react-native";
import { Space } from "../../space/Space";
import Divider from "../../divider/Divider";
import ButtonDLSBase from "../../button/ButtonDLS.base";
import Radio from "../../radio/Radio";
const DigioAgreementSignPage = ({ height, continueAction, triggerAction, digio_agreement_response, digioAgreementDeepCheckAction, digioDeepCheckSuccess, digioDeepCheckFailure, digio_status, hidePopUpAction, proceedToNextAction, contactUsAction, lenderInfo, showWebView, options, docketId, documentId, signerId, stepperProps, callWebApiAction, id, backAction, androidCallBackAction, updateProp, buildType, loading, returnToBase = false, showErrorCard, errorMessage, closeErrorModalAction, startKfsPollingAction, kfsGeneraterLoading = true, kfsUrl, isJupiter, apiFailureCard }) => {
    const [_showSuccessModal, setShowSuccessModal] = useState(false);
    const [_showFailureModal, setShowFailureModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalHeight, setModalHeight] = useState(276);
    const [isDismissable, setDismissable] = useState(false);
    const [_lenderInfo, setLenderInfo] = useState(lenderInfo);
    const [showWeb, setShowWebView] = useState(false);
    const [docId, setDocId] = useState("");
    const [docket, setDocketId] = useState("");
    const [signId, setSignId] = useState("");
    const [esignCancelled, setESignCancelled] = useState(false);
    const [successLottie, setSuccessLottie] = useState("");
    const [iLottieFetched, setLottieFetched] = useState(false);
    const [showAPIFailureCard, setShowAPIFailureCard] = useState(false);
    const [kfsClicked, setKfsClicked] = useState(false);
    const [buttonEnabled, setButtonEnabled] = useState(true);
    useEffect(() => {
        setShowAPIFailureCard(apiFailureCard);
    }, [apiFailureCard]);
    const script = `
      var options = {
        id: "tata-capital-financial-services-limited_combined_uat",
        docket_id: "64d749da3b15ca2fd8562edc",
        signer_id: "64d749da3b15ca2fd8562edf",
        document_id: "64d749da3b15ca2fd8562edd",
        widget_width: "50%",
        widget_height: "50%",
        getWidgetToken: function (result) {
          console.log("result here =>", result);
        },
        signatureStatus: function (result) {
          console.log(result);
        },
        errorLog: function (result) {
          console.log(result);
        },
      };
      esignWidgetCall(options);
    `;
    const webViewRef = React.useRef(null);
    const stepperDetails = {
        data: stepperProps,
        type: StepperTypeTokens.HORIZONTAL,
        onPress: null
    };
    useEffect(() => {
        const successJsonLottie = "https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json";
        fetch(successJsonLottie, {
            method: "GET",
        })
            .then((response) => response.json())
            .then((responseData) => {
            setSuccessLottie(responseData);
            setLottieFetched(true);
        })
            .catch((error) => {
            console.log(error);
        });
    }, [_showSuccessModal]);
    useEffect(() => {
        setShowWebView(showWebView);
    }, [showWebView]);
    // useEffect to know when to enable deep check
    useEffect(() => {
        if (digio_agreement_response) {
            digioAgreementDeepCheckAction &&
                triggerAction(digioAgreementDeepCheckAction);
        }
    }, [digio_agreement_response]);
    // useEffect when we get a status=cancel in digio redirect url
    useEffect(() => {
        if (digio_status === 'cancel') {
            showFailureModal();
        }
    }, [digio_status]);
    useEffect(() => {
        if (digioDeepCheckSuccess) {
            setDismissable(false);
            showSuccessModal();
        }
    }, [digioDeepCheckSuccess]);
    useEffect(() => {
        setTimeout(() => {
            if (digioDeepCheckFailure) {
                setDismissable(true);
                showFailureModal();
            }
        }, 500);
    }, [digioDeepCheckFailure, updateProp]);
    useEffect(() => {
        if (returnToBase) {
            setKfsClicked(false);
        }
    }, [returnToBase, updateProp]);
    useEffect(() => {
        if (_showSuccessModal) {
            setDismissable(false);
            setModalHeight(228);
            setTimeout(() => {
                moveToNextStep();
            }, 3000);
        }
        if (_showFailureModal) {
            setDismissable(true);
            setModalHeight(276);
        }
        if (showErrorCard) {
            setDismissable(true);
            setModalHeight(220);
        }
        if (showAPIFailureCard) {
            setModalHeight(220);
        }
    }, [_showSuccessModal, _showFailureModal, showErrorCard, showAPIFailureCard]);
    const moveToNextStep = () => {
        proceedToNextAction &&
            triggerAction(proceedToNextAction);
    };
    const handleEditButton = async () => {
        await triggerAction(closeErrorModalAction);
    };
    const handleCloseErrorModal = async () => {
        await triggerAction(closeErrorModalAction);
    };
    const errorModalContentPresenter = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, flex: 1 } },
            React.createElement(View, { style: { alignItems: 'center' } },
                React.createElement(Icon, { name: IconTokens.SystemError })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center, label: "Verification failed!" })),
            React.createElement(View, { style: { marginTop: 12 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center, label: errorMessage })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Edit Details', onPress: handleEditButton, isDisabled: false }))));
    };
    const hideModalRetryAgreement = () => {
        setShowModal(false);
        hidePopUpAction &&
            triggerAction(hidePopUpAction);
    };
    const openContactUs = () => {
        setShowModal(false);
        contactUsAction &&
            triggerAction(contactUsAction);
    };
    const showSuccessModal = () => {
        setShowFailureModal(false);
        setShowSuccessModal(true);
        setShowModal(true);
    };
    const showFailureModal = () => {
        setShowFailureModal(true);
        setShowSuccessModal(false);
        setShowModal(true);
    };
    const successModalContent = () => {
        return (React.createElement(View, { style: {
                width: '100%',
                padding: 16,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            } },
            Platform.OS !== 'web' ?
                React.createElement(LottieView, { source: { uri: "https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json" }, style: styles.successLottie, autoPlay: true, loop: true }) :
                React.createElement(Image, { size: ImageSizeTokens.Size_40, uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/StatusSuccess_1.svg', width: 48, height: 48 }),
            React.createElement(View, { style: { height: 16 } }),
            React.createElement(Typography, { label: 'Agreement signed successfully!', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, fontWeight: '600', lineHeight: 24 }),
            React.createElement(View, { style: { height: 4 } }),
            React.createElement(Typography, { label: ' You will be redirected to next step in few seconds', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, numberOfLines: 2 }),
            React.createElement(View, { style: { height: 24 } }),
            React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, label: 'Proceed to next step', fontFamily: FontFamilyTokens.Inter, onPress: () => {
                    moveToNextStep();
                } })));
    };
    const failureModalContent = () => {
        return (React.createElement(View, { style: {
                width: '100%',
                padding: 16,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            } },
            React.createElement(Image, { size: ImageSizeTokens.Size_40, uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/StatusFailed_1.svg', width: 48, height: 48 }),
            React.createElement(View, { style: { height: 16 } }),
            React.createElement(Typography, { label: 'Agreement signing failed!', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, fontWeight: '600', lineHeight: 24 }),
            React.createElement(View, { style: { height: 4 } }),
            React.createElement(Text, { style: {
                    fontFamily: 'Inter',
                    fontSize: 14,
                    fontWeight: '400',
                    lineHeight: 20,
                    textAlign: 'center',
                    color: '#667085',
                    marginBottom: 24
                } }, isMobile(getScreenType(Dimensions.get('window').width)) ? "We encountered an error while signing the loan agreement. Please retry the process." : "We encountered an error while signing the loan agreement.\nPlease retry the process."),
            React.createElement(Button, { type: ButtonTypeTokens.MediumSoftFilled, width: ButtonWidthTypeToken.FULL, label: 'Try again', fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, onPress: () => {
                    hideModalRetryAgreement();
                } }),
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: 16
                } },
                React.createElement(Text, { style: {
                        fontFamily: 'Inter',
                        fontSize: 14,
                        fontWeight: '400',
                        lineHeight: 24,
                        color: '#1D2939'
                    } }, "Need help?"),
                React.createElement(View, { style: { width: 5 } }),
                React.createElement(TouchableOpacity, { onPress: () => {
                        openContactUs();
                    } },
                    React.createElement(Typography, { label: "Contact us", fontSize: FontSizeTokens.SM, lineHeight: 24, fontWeight: "600", fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Primary_100 })))));
    };
    const modalContentPresenter = () => {
        return _showSuccessModal && iLottieFetched ? React.createElement(React.Fragment, null, successModalContent()) : _showFailureModal ? React.createElement(React.Fragment, null, failureModalContent()) : React.createElement(React.Fragment, null);
    };
    const handleProceedToAgreement = () => {
        continueAction &&
            triggerAction(continueAction);
    };
    const _bodyChild = () => {
        return (React.createElement(ScrollView, { style: {
                height: height - 210,
            } },
            React.createElement(View, { style: { marginTop: Platform.OS === 'ios' ? 36 : 0, marginLeft: -4 } },
                React.createElement(Image, { uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/loan-agreement.svg', size: ImageSizeTokens.SIZE_64, width: 64, height: 64 })),
            React.createElement(View, { style: {
                    height: Platform.OS === 'ios' ? height - 362 : height - 325,
                    marginTop: 4
                } },
                React.createElement(Text, { style: {
                        fontFamily: 'Poppins',
                        fontSize: 16,
                        fontWeight: '600',
                        fontStyle: 'normal',
                        lineHeight: 24,
                        color: '#1D2939',
                        marginTop: Platform.OS === "ios" ? 16 : 0
                    } }, "Proceed to sign agreement"),
                React.createElement(View, { style: {
                        marginTop: 4
                    } },
                    React.createElement(Text, { style: {
                            fontFamily: 'Inter',
                            fontSize: 14,
                            fontWeight: '400',
                            fontStyle: 'normal',
                            lineHeight: 20,
                            color: '#667085'
                        } }, "Proceed to review & confirm the loan cum pledge agreement.")))));
    };
    const renderApiFailureCard = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, flex: 1 } },
            React.createElement(View, { style: { alignItems: 'center' } },
                React.createElement(Icon, { name: IconTokens.SystemError })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center, label: "Verification failed!" })),
            React.createElement(View, { style: { marginTop: 12 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center, label: "Please try again after sometime" })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.SECONDARY, label: "Continue", onPress: () => {
                        setShowAPIFailureCard(false);
                    }, isDisabled: false }))));
    };
    const _footerChild = () => {
        return (React.createElement(View, { style: {
                width: '100%',
            } },
            React.createElement(View, { style: { flexDirection: 'row' } },
                React.createElement(TouchableOpacity, { onPress: () => {
                    } },
                    React.createElement(Radio, { id: 'rb_kycConfirmation_check', color: ColorTokens.Primary_100, isChecked: true, size: IconSizeTokens.MD, onPressUnChecked: () => {
                            console.warn("BUTTON H");
                            setButtonEnabled(false);
                        }, onPressChecked: () => {
                            setButtonEnabled(true);
                        } })),
                React.createElement(View, { style: { marginLeft: 8 } },
                    React.createElement(Text, null,
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: isMobileView() ? `I understand acknowledge and agree to terms in\n` : `I understand acknowledge and agree to terms in ` }),
                        React.createElement(TouchableOpacity, { activeOpacity: kfsClicked ? 1 : 0, onPress: () => {
                                if (triggerAction && !kfsClicked) {
                                    triggerAction(startKfsPollingAction);
                                    setKfsClicked(true);
                                }
                            } },
                            React.createElement(Text, { style: { flexShrink: 1 } },
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, color: kfsClicked ? ColorTokens.Grey_Night : ColorTokens.Primary_100, label: "Key fact statement" })))))),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Button, { id: "bt_reviewAgreement_proceedReviewAgreement", type: buttonEnabled ? ButtonTypeTokens.LargeFilled : ButtonTypeTokens.LargeOutline, label: "Proceed to the next step", fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, isDisabled: buttonEnabled, width: ButtonWidthTypeToken.FULL, loading: loading, onPress: () => {
                        if (buttonEnabled)
                            handleProceedToAgreement();
                    } })),
            React.createElement(View, { style: { height: 8 } }),
            React.createElement(View, { style: {
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center'
                } },
                React.createElement(Typography, { label: " LENDING PARTNER", fontWeight: '400', fontSize: FontSizeTokens.XS, lineHeight: 16, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal }),
                React.createElement(View, { style: { width: 8 } }),
                React.createElement(View, { style: { paddingBottom: _lenderInfo?.lenderAccountId === "Mirae" ? 8 : 0, marginLeft: _lenderInfo?.lenderAccountId === "DSP" ? -62 : 0 } },
                    React.createElement(Icon, { name: getLenderIcon(_lenderInfo?.lenderAccountId) })))));
    };
    const handleWebViewLoad = (value) => {
        if (callWebApiAction) {
            triggerAction({
                ...callWebApiAction,
                payload: { result: value },
            });
        }
    };
    const handleWebViewError = (value) => {
        if (androidCallBackAction) {
            triggerAction({
                ...androidCallBackAction,
                payload: { result: value },
            });
        }
    };
    const onMessage = (event) => {
        if (event.nativeEvent?.data === "failed" || event.nativeEvent?.data === "success") {
            handleWebViewError(event.nativeEvent.data);
        }
        else {
            try {
                handleWebViewLoad(event.nativeEvent.data);
            }
            catch (error) {
                console.error('Error processing WebView message:', error);
            }
        }
    };
    const SignDeskSDKUrl = buildType === "BORROWER_PRODUCTION"
        ? 'https://signdesk.in/api/eSignWidgetLive.js'
        : 'https://signdesk.in/api/eSignWidgetUat.js';
    const renderWebView = () => {
        return (React.createElement(View, { style: [
                styles.container,
                { height: Platform.OS === "ios" ? height - 30 : height }
            ] },
            React.createElement(Space, { size: SizeTypeTokens.XXXL }),
            React.createElement(WebView, { containerStyle: { height: Platform.OS === "ios" ? 260 : 300, width: '100%', marginTop: 30 }, style: { height: Platform.OS === "ios" ? 260 : 300, width: '100%' }, scalesPageToFit: true, originWhitelist: ['*'], useWebKit: true, ref: webViewRef, source: {
                    html: ` 
          <html>
<body>
<script type="text/javascript" src="${SignDeskSDKUrl}"></script>
<script type="text/javascript">
         var options = {
            id: "${id}",
            docket_id: "${docketId}",
        signer_id: "${signerId}",
        document_id: "${documentId}",
                    widget_width:"100%", //optional
            widget_height:"100%", //optional

            getWidgetToken: function (resulta) {
                setTimeout(()=> {
                 sendDataToReactNativeApp(resulta);
   
                },(1000))
            }, 
            signatureStatus: function (result) {
                 sendDataToReactNativeApp(result.status);

            },
            errorLog: function (result) {
                console.log("RESULT RECEIVED FROM ERROR", result.status,result.error)
               console.log(result);
            },
         };
        esignWidgetCall(options);
        
           const sendDataToReactNativeApp = async (data) => {
                window.ReactNativeWebView.postMessage(data);
              };
      </script>
</body>
</html>
`,
                }, onMessage: onMessage, javaScriptEnabled: true, javaScriptEnabledAndroid: true, javaScriptCanOpenWindowsAutomatically: true, allowFileAccess: true, domStorageEnabled: true, mixedContentMode: 'always', mediaPlaybackRequiresUserAction: false, allowsInlineMediaPlayback: true })));
    };
    return showWeb ? renderWebView() : (React.createElement(View, { style: [
            styles.container,
            { height: Platform.OS === "ios" ? height - 14 : height }
        ] },
        React.createElement(View, { style: {
                flex: 1
            } },
            React.createElement(View, { style: styles.headerStyle },
                React.createElement(Header, { id: "bt_reviewAgreement_goBack", type: kfsClicked ? HeaderTypeTokens.DEFAULT : HeaderTypeTokens.verification, stepperProps: stepperDetails, isBackButton: true, needHelpIcon: true, isFromJupiter: isJupiter, needHelpAction: () => triggerAction(contactUsAction), title: "Review Agreement", onPress: () => {
                        if (backAction) {
                            if (kfsClicked) {
                                setKfsClicked(false);
                            }
                            else {
                                triggerAction(backAction);
                            }
                        }
                    } })),
            kfsClicked ?
                kfsGeneraterLoading ?
                    React.createElement(View, { style: { position: "absolute", right: 0, left: 0, bottom: 0, top: 0, marginTop: 200 } },
                        React.createElement(ActivityIndicator, { size: "large", color: 'blue' })) :
                    Platform.OS === 'ios' ? (React.createElement(View, { style: { width: '100%', height: height - 120 } },
                        React.createElement(WebView, { style: {
                                width: '100%',
                                marginBottom: 140,
                                marginTop: 20
                            }, source: { uri: kfsUrl }, javaScriptEnabled: true, domStorageEnabled: true, originWhitelist: ['*'], automaticallyAdjustContentInsets: false, useWebKit: true, allowsInlineMediaPlayback: true, scalesPageToFit: true, scrollEnabled: true, mediaPlaybackRequiresUserAction: false, javaScriptEnabledAndroid: true, showsHorizontalScrollIndicator: false, nestedScrollEnabled: true }))) :
                        React.createElement(WebView, { source: { uri: kfsUrl } })
                : React.createElement(View, { style: [styles.body, { height: height - 108 }] }, _bodyChild()),
            React.createElement(View, { style: styles.footer },
                !kfsClicked && React.createElement(View, { style: {
                        flexDirection: 'row',
                        backgroundColor: '#F1F3F5',
                        borderRadius: 6,
                        padding: 12,
                        marginBottom: 8,
                        marginHorizontal: 4,
                    } },
                    React.createElement(View, { style: { marginRight: 8 } },
                        React.createElement(Icon, { name: IconTokens.Illustration, size: IconSizeTokens.XS, color: ColorTokens.Grey_Smoke })),
                    React.createElement(View, { style: { width: '90%' } },
                        React.createElement(Typography, { label: "You'll be redirected to our lending partner's site to review and sign the loan agreement.", fontWeight: '400', fontSize: FontSizeTokens.XS, lineHeight: 18, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, numberOfLines: 2 }))),
                React.createElement(View, { style: { marginBottom: 16, marginHorizontal: -16 } },
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                React.createElement(View, null, _footerChild()))),
        showModal &&
            React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0
                } },
                React.createElement(BottomSheet, { autoAdjustHeight: false, height: modalHeight, width: '100%', closeFunction: async () => {
                        hidePopUpAction &&
                            await triggerAction({
                                ...hidePopUpAction
                            });
                        setShowModal(false);
                    }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: isDismissable, radius: 4, screenHeight: height - 4, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true }, modalContentPresenter())),
        showErrorCard &&
            React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0
                } },
                React.createElement(BottomSheet, { autoAdjustHeight: false, height: modalHeight, width: '100%', closeFunction: handleCloseErrorModal, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: isDismissable, radius: 4, screenHeight: height - 4, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true }, errorModalContentPresenter())),
        showAPIFailureCard &&
            React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0
                } },
                React.createElement(BottomSheet, { autoAdjustHeight: false, height: modalHeight, width: '100%', closeFunction: () => {
                        setShowAPIFailureCard(false);
                    }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: height - 4, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true }, renderApiFailureCard()))));
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
const styles = StyleSheet.create({
    container: {
        width: '100%',
    },
    header: {
        paddingHorizontal: 16,
        paddingTop: 12,
        paddingBottom: 12,
        borderBottomWidth: 1,
        borderBottomColor: '#F1F3F5',
        backgroundColor: '#FFF',
        shadowOffset: { width: 0, height: 1 },
        shadowColor: 'rgba(208, 213, 221, 0.25)',
        shadowOpacity: 1,
        shadowRadius: 6,
        elevation: 1,
        height: 50
    },
    successLottie: { width: 70, height: 70 },
    body: {
        paddingHorizontal: 16,
        paddingTop: 24
    },
    footer: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        backgroundColor: '#FFF',
        padding: 16,
        marginTop: 16,
    },
    groupContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    transactionCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
    },
    transactionLeftCardContainer: {
        flex: 3,
        display: 'flex',
        flexDirection: 'row',
    },
    transactionRightCardContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end'
    },
    webview: {
        flex: 1,
    },
    headerStyle: { width: '100%', flex: 1, ...Platform.OS === "ios" && {
            marginTop: 24
        } },
    modalContainer: {
        alignItems: "center",
        padding: 16,
        flex: 1
    },
});
export default (DigioAgreementSignPage);
